/* eslint-disable react/prop-types */
import React from 'react';
import dataSuccess from 'data/dataSuccess';
import SuccessPage from 'components/success/SuccessPage';
import CommentBlock from 'components/success/CommentBlock';

class SuccessFile extends React.Component {
  render() {
    return (
      <SuccessPage {...this.props}>
        <CommentBlock>{dataSuccess[this.props.success].paragraph}</CommentBlock>
      </SuccessPage>
    );
  }
}

export default SuccessFile;
